import React, { useEffect, useState } from 'react';
import { Alert, Card, CardBody, Col, Modal, ModalBody, Row } from 'reactstrap';
import Spinners from 'components/Common/Spinner';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import { Link } from 'react-router-dom';
import getBadgesData from 'components/Common/BadgesData';
import moment from 'moment';
import { setSelectedBooking } from 'store/actions';
import { useDispatch } from 'react-redux';
import { taskBadges } from 'constants/layout';

const BookingList = props => {
	let { bookingList } = props;
	const [modalVisible, setModalVisible] = useState(false);
	const [selectedData, setSelectedData] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		setTimeout(() => {
			const element = document.getElementById(props.selectedBookingId);
			if (element) {
				element?.scrollIntoView({
					block: 'nearest',
					behavior: 'smooth'
				});
			}
		}, 2000);
	}, [props.bookingList]);

	const getOperationUser = data => {
		if (props?.internalUsersList && props?.internalUsersList?.length > 0) {
			let bookingUser = {};
			if (data?.handlingOpertationUserId) {
				bookingUser = props.internalUsersList.find(item => item._id == data?.handlingOpertationUserId);
			}

			return bookingUser?.firstname
				? bookingUser?.firstname?.toUpperCase() + ' ' + bookingUser?.lastname?.toUpperCase()
				: 'Not Assigned';
		}

		return 'Not Assigned';
	};

	const getAccountUser = data => {
		if (props?.internalUsersList && props?.internalUsersList?.length > 0) {
			let accountUser = {};
			if (data?.handlingAccountUserId) {
				accountUser = props.internalUsersList.find(item => item._id == data?.handlingAccountUserId);
			}
			return accountUser?.firstname
				? accountUser?.firstname?.toUpperCase() + ' ' + accountUser?.lastname?.toUpperCase()
				: 'Not Assigned';
		}

		return 'Not Assigned';
	};

	return (
		<React.Fragment>
			{props.isLoading ? (
				<Col xs="12">
					<Spinners setLoading={() => {}} />
				</Col>
			) : (
				<Col xs="12">
					<Card>
						<CardBody>
							<Row>
								<Col sm="12">
									<div className="table-responsive">
										<table className="table align-middle table-nowrap mb-0 fixed-first-column">
											<thead className="table-light font-size-11">
												<tr className="text-center">
													<th>Sr #</th>
													<th>Booking Number</th>
													<th>Booking Type</th>
													<th>Shipment Type</th>
													<th>Shipping Line</th>
													<th>Loading Point</th>
													<th>POL</th>
													<th>POD</th>
													<th>FPOD</th>
													<th>Containers</th>

													<th>Action</th>
												</tr>
											</thead>
											<tbody key={'bookings-table'} className="font-size-11">
												{bookingList?.length > 0 &&
													bookingList?.map((item, index) => (
														<tr
															key={'bookings-table-' + index}
															className={
																props.selectedBookingId == item._id ? 'table-secondary text-center' : 'text-center'
															}
															id={item._id}
														>
															<td>{index + 1}</td>
															<td>{item?.bookingNumber}</td>
															<td>{item?.bookingType ? getBadgesData(item?.bookingType) : '-'}</td>
															<td>{item?.shipmentType}</td>
															<td>
																{getShippingLineLinkUrl(item?.shippingLineData?.companyname, item?.bookingNumber)}
															</td>
															<td>{item?.loadingLocation}</td>
															<td>
																{item?.polLocation}
																{<br />}({item?.polCountry}){<br />} ({moment(item.etdDate).format('DD-MM-YYYY')})
															</td>
															<td>
																{item?.podLocation}
																{<br />}({item?.podCountry}){<br />} ({moment(item.etaDate).format('DD-MM-YYYY')})
															</td>
															<td>{item?.fpodLocation}</td>
															<td>{item?.noOfContainer}</td>

															<td>
																<Link
																	to={`/booking-details/${item?.bookingNumber}`}
																	onClick={() => dispatch(setSelectedBooking(item._id))}
																>
																	<i className="fa fa-eye hover-cursor-pointer font-size-14 text-dark"></i>
																</Link>
															</td>
														</tr>
													))}
												{bookingList?.length === 0 && (
													<tr key={'customer-member-empty'}>
														<td className="text-center" colSpan="7">
															No Booking Found
														</td>
													</tr>
												)}
											</tbody>
										</table>
									</div>
								</Col>
							</Row>
						</CardBody>
					</Card>

					<Modal
						isOpen={modalVisible}
						role="dialog"
						autoFocus={true}
						centered={true}
						className="exampleModal"
						tabIndex="-1"
					>
						<div className="modal-content">
							<ModalBody className="py-4">
								<div className="text-center">
									<button
										onClick={() => setModalVisible(false)}
										className="btn-close position-absolute end-0 top-0 m-3"
									/>
									<p className="font-size-14 mb-4">{selectedData?.operation ? 'Operation Task' : 'Finance Data'}</p>
								</div>
								<Row>
									{selectedData.operation
										? selectedData?.operation.map((item, index) => (
												<Col md="4" key={index} className="text-center mt-2 mb-3 font-size-10">
													<h4 className="font-size-10">{item.name}</h4>
													<span className="font-size-10">
														{moment(item?.startDate?.split('T')[0]).format('DD-MM-YYYY')}
													</span>
													{item?.dueDate != item.startDate && (
														<span className="font-size-10">
															- {moment(item?.dueDate?.split('T')[0]).format('DD-MM-YYYY')}
														</span>
													)}
													<br />
													<span
														className={`badge badge-soft mt-1 font-size-10 ${
															{
																...taskBadges
															}[item?.currentStatusValue]
														}`}
													>
														{item?.currentStatusValue}
													</span>
												</Col>
										  ))
										: selectedData?.finance?.map(
												(item, index) =>
													item?.partyModel == 'TraxaaClient' && (
														<Col md="6" key={index} className="text-center mt-3">
															<h4 className="font-size-10">{item?.partyName}</h4>
															<div className="list-inline text-center">
																{item?.status == 'Profit' ? (
																	<span className="badge bg-success p-1 list-inline-item">Profit</span>
																) : (
																	<span className="badge bg-danger p-1 list-inline-item">Loss</span>
																)}
																<h5 className="list-inline-item font-size-10">
																	{item?.currency} {parseFloat(item?.amount).toFixed(2)}
																</h5>
															</div>
														</Col>
													)
										  )}
								</Row>
							</ModalBody>
						</div>
					</Modal>
				</Col>
			)}
		</React.Fragment>
	);
};
export default BookingList;
